<template>
    <div class="dvgraficoline">
        <v-chart  :options="options"/>
    </div>
</template>
<style>
 
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/lines'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'

export default {
    name : "cmpgraficoline",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'agrupamento',
		'series'
        
    ],
    data () {
        return {
            options : {
               
                color: [
						'#6610f2',  // Indigo
						'#593196',  // Purple
						'#8a5ff2',  // Indigo mais claro
						'#4c0a9c',  // Indigo mais escuro
						'#7a53b3',  // Purple mais claro
						'#4e318a',  // Purple mais escuro
						'#f26135',  // Laranja
						'#40c057',  // Verde
						'#ffc107',  // Amarelo
						'#333333',  // Cinza escuro
						'#cccccc'   // Cinza claro
					],

                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show  : false,
                            title : 'Salvar gráfico'                            
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: []
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        series(){
            this.options.title.text     			= this.titulo;
            this.options.xAxis.data 			    = this.agrupamento;
			this.options.series                     = this.series;			
        }
    }    
}
</script>
<style scoped>
  
</style>